export default "__VITE_ASSET__B8G_LstK__"